export default __webpack_public_path__ + "locales/sr-Latn-RS/Article.json?hash=df7df99e243e989f9582869a559580b2";